<div class="authTemplate contenedor" [ngClass]="{ esModal: esModal }">
  <div class="row arriba" *ngIf="!esModal">
    <div class="col-12 col-lg-6 p-4">
      <div class="w-100 d-flex justify-content-between">
        <a href="" class="btn text-white" (click)="back()">ATRÁS</a>
        <a href="/home" class="btn text-white">HOME</a>
        <!-- <a routerLink="/home" class="btn text-white">HOME</a> -->
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-lg-6 p-5">
      <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <div class="caja">
          <form class="text-center" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="titulo">Iniciar sesión en +Cinemateca</div>

            <!-- Email -->
            <div class="form-group mb-4 text-left">
              <input type="email" class="form-control" placeholder="E-mail" formControlName="email" />

              <ng-container *ngIf="loginForm.get('email').invalid && loginForm.get('email').touched">
                <div *ngIf="loginForm.get('email').errors?.required" class="text-danger">Debe ingresar un correo.</div>
                <div *ngIf="loginForm.get('email').errors?.email" class="text-danger">
                  Debe ingresar un correo válido.
                </div>
              </ng-container>
            </div>

            <!-- Password -->
            <div class="form-group mb-4 text-left">
              <div class="input-group-icon">
                <input type="password" class="form-control ojito-cerrado icon-btn" placeholder="Password"
                  formControlName="password" id="password" />

                <!-- ICONOS OJITOS -->
                <div class="input-group-append btn" (click)="alternarVerPassword('password')">
                  <span class="icon ojito-slash" *ngIf="verPassword">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye-slash" fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z" />
                      <path
                        d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299l.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z" />
                      <path
                        d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709z" />
                      <path fill-rule="evenodd" d="M13.646 14.354l-12-12 .708-.708 12 12-.708.708z" />
                    </svg>
                  </span>

                  <span class="icon ojito-abierto" *ngIf="!verPassword">
                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-eye" fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd"
                        d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.134 13.134 0 0 0 1.66 2.043C4.12 11.332 5.88 12.5 8 12.5c2.12 0 3.879-1.168 5.168-2.457A13.134 13.134 0 0 0 14.828 8a13.133 13.133 0 0 0-1.66-2.043C11.879 4.668 10.119 3.5 8 3.5c-2.12 0-3.879 1.168-5.168 2.457A13.133 13.133 0 0 0 1.172 8z" />
                      <path fill-rule="evenodd"
                        d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
                    </svg>
                  </span>
                </div>
              </div>

              <ng-container *ngIf="loginForm.get('password').invalid && loginForm.get('password').touched">
                <div *ngIf="loginForm.get('password').errors?.required" class="text-danger">
                  Debe ingresar la contraseña.
                </div>
              </ng-container>
            </div>

            <div class="text-left">
              <a href="/olvido">¿Te olvidaste de la contraseña?</a>
            </div>

            <!-- Sign in button -->
            <div class="form-group mt-3">
              <button class="btn btn-block btn-lg my-4" type="submit" [ngClass]="{ disabled: !loginForm.valid }">
                <span *ngIf="cargando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span *ngIf="!cargando">Acceder</span>
              </button>
            </div>

            <!-- Register -->
            <p>¿No tenés una cuenta? <a (click)="register()">Registrate</a></p>
          </form>
        </div>
      </div>
    </div>

    <div class="col-6 p-0 d-none d-lg-inline">
      <div class="imagen"></div>
      <div class="mosaico"></div>
    </div>
  </div>
</div>